import { useEffect } from "react";

const AOPromotionRedirect = () => {
  useEffect(() => {
    window.location.href = "/AOPromotion-01092025.pdf";
  }, []);

  return null;
};

export default AOPromotionRedirect;
